import React from 'react'
import HelmetMeta from './components/core-template/HelmetMeta'
import Header from './components/core-template/Header'
import HeadlineCard from './components/core-template/HeadlineCard'
import Footnote from './components/core-template/Footnote'
import Byline from './components/core-template/Byline'
import Footer from './components/core-template/Footer'
import Elements from './components/Elements'
import datum from './data/datum.json'
import './App.scss'

function App () {
  const els = datum.content.map(d => <Elements {...d} key={d.id} />)

  return (
    <>
      <HelmetMeta {...datum.config} />
      <div className='story-wrapper'>
        <Header />
        <HeadlineCard {...datum.config} />
        <div className='content-wrapper'>
          {els}
          <Footnote notes={datum.footnotes} />
          <Byline byline={datum.config.byline}></Byline>
        </div>
        <Footer {...datum.config} />
      </div>
    </>
  )
}

export default App
